import { render } from "./AmenitiesForm.vue?vue&type=template&id=4072a9df"
import script from "./AmenitiesForm.vue?vue&type=script&lang=js"
export * from "./AmenitiesForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__